// Module
var code = `<customer-page>
  <sub-header header="\$ctrl.header"></sub-header>
  <customer-loan-create-details ng-form="\$ctrl.loanForm"
                                loan="\$ctrl.loan"
                                loan-type-id="\$ctrl.loanTypeId"
                                edit-mode="true"></customer-loan-create-details>

  <div class="summary-actions">
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
    <button type="button" class="btn btn-primary" ng-click="\$ctrl.open()"
            ng-disabled="\$ctrl.loanForm.\$invalid">
      Open
    </button>
  </div>
</customer-page>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/customer-loan-create-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;